import { useAppSelector } from '@/hooks/store';
import { Alert } from '@odekoteam/doppio';
import { Error } from '@/state/errors';
import { notify } from '@/services/ErrorReporter';

const ErrorBanner = () => {
  const errors = useAppSelector((state) => state.errors.errors);
  const hasErrors = errors && errors.length > 0;

  return (
    <div sx={{ wordBreak: 'break-word' }}>
      {hasErrors && (
        <Alert variant="error">
          {errors
            .map((error: Error) => {
              notify(error);
              let msg = '';

              if (error.code) {
                msg += `${error.code}: `;
              }

              msg += error.message;

              return msg;
            })
            .join('<br>')}
        </Alert>
      )}
    </div>
  );
};

export default ErrorBanner;
